import { render, staticRenderFns } from "./InvoiceLine.vue?vue&type=template&id=4ff2a0e6"
import script from "./InvoiceLine.vue?vue&type=script&lang=js"
export * from "./InvoiceLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports